import { FormsActionTypes } from '@bimser/common';
import { createSyncAction, IBaseAction } from '@bimser/core';
import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { put, takeEvery } from 'redux-saga/effects';

export default function* watchFormItemsLoad() {
	yield takeEvery(FormsActionTypes.FORM_ITEMS_LOADED_TRANSACTION, formItemsLoad);
}

export function* formItemsLoad(action: IBaseAction<LayoutCreatorEntities.FormItemsLoadAction>) {
	try {
		yield put(createSyncAction(FormsActionTypes.FORM_ITEMS_LOADED, action.payload));
	} catch (error) {
		console.log('LOG: function*formItemsLoad -> error', error);
	}
}
